import { render, staticRenderFns } from "./GfuLogo.vue?vue&type=template&id=ce2ac154&scoped=true"
var script = {}
import style0 from "./GfuLogo.vue?vue&type=style&index=0&id=ce2ac154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce2ac154",
  null
  
)

export default component.exports